import { useEffect, useState } from "react";
import { Card, Typography } from "@material-tailwind/react";
import { get } from "lodash";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useParse, useTranslation } from "@refinedev/core";
import useWindowWidth from "utills/InitWidthDevice";
import ApiService from "utills/ApiService";
import Pagination from "components/wps/Pagination";
import { FullScreenLoading } from "components/fullScreenLoading";
import toast from "react-hot-toast";
import { Breadcrumbs } from "components/breadcrumbs";
import FilterEvent from "./filterEvent";
import TicketGroup from "./ticketGroup";
import TShirtBoard from "./tShirtBoard";
import Participants from "./participants";
import OrderPending from "./orderPending";

interface WPSDashboardEentProps {
  hideDashboardLayout?: boolean;
}

const WPSDashboardEent = ({ hideDashboardLayout = false }: WPSDashboardEentProps) => {
  const { translate, getLocale } = useTranslation();
  const language = getLocale();
  const [applyDate, setApplyDate] = useState({
    start: '',
    end: ''
  });
  const [ticketTab, setTicketTab] = useState(0);

  const [events, setEvents] = useState([] as any);
  const [loading, setLoading] = useState(false);
  const [category, setCategory] = useState(null as any);
  const [tShirtPage, setTShirtPage] = useState(0);
  const [attendantPage, setAttendantPage] = useState(1);
  const [attendantPaging, setAttendantPaging] = useState(null as any);
  const [filter, setFilter] = useState(false);
  const [symbolCurrency, setSymbolCurrency] = useState('đ');
  const [currentCurrency, setCurrentCurrency] = useState('vnd');
  const windowWidth = useWindowWidth();
  const [isMobile, setIsMobile] = useState(false);

  const [token, setToken] = useState('');

  useEffect(() => {
    const user = localStorage.getItem("USER");

    if (user) {
      const userData = JSON.parse(user);
      setToken(userData?.token);
    }
  }, []);

  useEffect(() => {
    if (windowWidth && windowWidth < 1024) {
      setIsMobile(true);
    } else {
      setIsMobile(false);
    }
  }, [windowWidth]);

  useEffect(() => {
    const wsCurrency = localStorage.getItem('wsCurrency');

    if (wsCurrency && wsCurrency.toLowerCase() === 'usd') {
      setSymbolCurrency('$');
      setCurrentCurrency('usd');
    } else {
      setSymbolCurrency('đ');
      setCurrentCurrency('vnd');
    }
  }, []);

  const ticketTypes = [
    {
      value: '',
      label: translate('all-types')
    },
    {
      value: 'individual',
      label: translate('individual-type')
    },
    {
      value: 'group_buy',
      label: translate('group-type')
    },
    {
      value: 'change_distance',
      label: translate('change-distance-type')
    },
    {
      value: 'transfer_ticket',
      label: translate('transfer-type')
    },
  ] as any;

  const [ticketTypeSelected, setTicketTypeSelected] = useState('');

  const [eventType, setEventType] = useState('');
  const [searchParams] = useSearchParams();
  const paramsObject = Object.fromEntries([...searchParams]);
  const navigate = useNavigate();
  const [initParams, setInitParams] = useState(true);
  const [suffix, setSuffix] = useState('');
  const ticket_platform_option = [
    {
      value: '',
      label: translate('all_platform')
    },
    {
      value: "actiup",
      label: translate('actiup_platform')
    },
    {
      value: "partner",
      label: translate('partner_platform')
    }
  ] as any;
  const [ticketPlatform, setTicketPlatform] = useState(ticket_platform_option[0].value);
  const [showPlatform, setShowPlatform] = useState(false);
  const parse = useParse();
  const { params } = parse();
  const [eventID, setEventID] = useState(params?.event_id);

  const breadcrumbItems = [
    {
      label: 'Dashboard',
      href: ''
    }
  ];

  useEffect(() => {
    if (token !== '') {
      handleCheckShowPlatform();
    }
  }, [token]);

  const handleCheckShowPlatform = async () => {
    try {
      const result = await ApiService.get(`orders/whitelabel/existed`, token);

      if (result && result?.whitelabel_orders_existed) {
        setShowPlatform(true);
      }


    } catch (error: any) {
      toast.error(error.message);
    }
  }

  useEffect(() => {
    if (initParams) {
      const keys = Object.keys(paramsObject);

      if (keys?.length > 0) {
        handleInitSearchValue();
      } else {
        setFilter(true);
        setInitParams(false);
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initParams]);

  const handleInitSearchValue = () => {
    if (paramsObject.from_date && paramsObject.from_date !== '') {
      setApplyDate({
        start: paramsObject.from_date,
        end: paramsObject.to_date
      })
    }

    if (paramsObject.eventID && paramsObject.eventID !== '') {
      setEventID(paramsObject.eventID);
    }

    setInitParams(false);

    const intervalShowEvent = setInterval(() => {
      setFilter(true);
      clearInterval(intervalShowEvent);
    }, 1000);

  }



  useEffect(() => {
    handleUpdateRoute();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [eventID, ticketPlatform])

  const handleUpdateRoute = () => {
    const newSearchParams = new URLSearchParams(searchParams);

    newSearchParams.set('from_date', applyDate.start);
    newSearchParams.set('to_date', applyDate.end);
    newSearchParams.set('event_id', eventID);
    newSearchParams.set('ticket_platform', ticketPlatform);

    const newParamsObject = Object.fromEntries([...newSearchParams]);

    const keys = Object.keys(newParamsObject);
    let changeRoute = false;

    if (keys?.length > 0) {
      keys?.forEach((key: string) => {
        if (newParamsObject[key] !== '') {
          changeRoute = true;
        }
      });
    }

    if (changeRoute || !initParams) {
      navigate(`?${newSearchParams.toString()}`, { replace: true });
      setFilter(true);
    }
  }

  useEffect(() => {
    if (token !== '' && events.length === 0) {
      fetchEvents();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [events, eventID, token]);

  const fetchEvents = async () => {
    try {
      const result = await ApiService.get(`events`, token);

      if (result && result.length > 0) {
        const arr = [] as any;

        result.forEach((item: any) => {
          if (item.id !== "all") {
            const obj = {
              value: item.id,
              label: get(item, `name_${language}`, ''),
              type: item.event_type
            };

            arr.push(obj);
          }
        })

        if (arr.length > 0) {
          setEvents(arr);

          if (!eventID || eventID === '') {
            setEventID(arr[0].value);
            setEventType(arr[0].type);
          } else {
            arr.forEach((item: any) => {
              if (eventID === item.value) {
                setEventType(item.type);
              }
            })
          }
        }

      } else {
        setEvents([]);
        setEventID('');
        setLoading(false);
      }
    } catch (error: any) {
      toast.error(error.message);
      setLoading(false);
    }
  }









  const shortenNumber = (num: number, type?: any) => {
    if (num > 0) {
      if (num >= 1000000000000) {
        let shortened = (num / 1000000000000) as any;
        shortened = (Math.floor(shortened * 10) / 10).toFixed(1);
        return shortened.endsWith('.0') ? shortened.slice(0, -2) + 'T' : shortened + 'T';
      } else if (num >= 1000000000) {
        let shortened = (num / 1000000000) as any;
        shortened = (Math.floor(shortened * 10) / 10).toFixed(1);
        return shortened.endsWith('.0') ? shortened.slice(0, -2) + 'B' : shortened + 'B';
      } else if (num >= 1000000) {
        let shortened = (num / 1000000) as any;
        shortened = (Math.floor(shortened * 10) / 10).toFixed(1);
        return shortened.endsWith('.0') ? shortened.slice(0, -2) + 'M' : shortened + 'M';
      } else if (num >= 1000) {
        let shortened = (num / 1000) as any;
        shortened = (Math.floor(shortened * 10) / 10).toFixed(1);
        return shortened.endsWith('.0') ? shortened.slice(0, -2) + 'K' : shortened + 'K';
      } else {
        if (type && type === 'number') {
          return num;
        } else {
          return num.toFixed(2);
        }
      }
    } else {
      return 0;
    }
  }


  return (
    <div id="event-tab">
      {!hideDashboardLayout && <Breadcrumbs type="wps" breadcrumbItems={breadcrumbItems} />}
      <div className={`w-full ${!isMobile && 'p-[16px]'}`}>
        {!hideDashboardLayout && (
          <div className={`w-full ${isMobile ? 'grid grid-cols-2 pt-[12px] px-[16px]' : 'mb-[16px] flex items-center'}`}>
            <Link to="/dashboard/overview">
              <div className={`${isMobile && 'w-full'} flex items-center justify-center text-16 font-500 w-[120px] text-[#718ebf] cursor-pointer pb-[8px]`}>{translate('overview')}</div>
            </Link>

            <div className={`${isMobile && 'w-full'} border-b-[3px] border-[#1814f3] flex items-center justify-center pb-[8px] text-16 font-500 w-[120px] text-[#1814f3] cursor-default`}>{translate('event')}</div>
          </div>
        )}

        {
          eventID !== '' &&
          <FilterEvent
            translate={translate}
            events={events}
            setEventID={setEventID}
            setTShirtPage={setTShirtPage}
            setCategory={setCategory}
            setAttendantPage={setAttendantPage}
            setEventType={setEventType}
            setApplyDate={setApplyDate}
            isMobile={isMobile}
            suffix={suffix}
            setSuffix={setSuffix}
            setFilter={setFilter}
            showPlatform={showPlatform}
            ticket_platform_option={ticket_platform_option}
            setTicketPlatform={setTicketPlatform}
            eventID={eventID} />
        }

        <TicketGroup
          ticketTab={ticketTab}
          setTicketTab={setTicketTab}
          translate={translate} eventType={eventType}
          ticketTypes={ticketTypes}
          setTicketTypeSelected={setTicketTypeSelected}
          isMobile={isMobile}
          setLoading={setLoading}
          token={token}
          eventID={eventID}
          applyDate={applyDate}
          ticketTypeSelected={ticketTypeSelected}
          ticketPlatform={ticketPlatform}
          language={language}
          currentCurrency={currentCurrency}
          setFilter={setFilter}
          filter={filter}
          events={events}
          shortenNumber={shortenNumber}
          symbolCurrency={symbolCurrency} />

        <TShirtBoard
          ticketTab={ticketTab}
          translate={translate}
          isMobile={isMobile} token={token} eventID={eventID} language={language} setCategory={setCategory} setTShirtPage={setTShirtPage} tShirtPage={tShirtPage} applyDate={applyDate} setLoading={setLoading} category={category} filter={filter} ticketPlatform={ticketPlatform} />

        <Participants
          ticketTab={ticketTab} translate={translate} isMobile={isMobile} token={token} eventID={eventID} applyDate={applyDate}
          filter={filter} ticketPlatform={ticketPlatform} attendantPage={attendantPage} setAttendantPaging={setAttendantPaging} attendantPaging={attendantPaging} language={language} setAttendantPage={setAttendantPage} />

        <OrderPending
          token={token} eventID={eventID} applyDate={applyDate}
          filter={filter} currentCurrency={currentCurrency} ticketPlatform={ticketPlatform}
          ticketTab={ticketTab} translate={translate} symbolCurrency={symbolCurrency}
          shortenNumber={shortenNumber} attendantPaging={attendantPaging} setAttendantPage={setAttendantPage} isMobile={isMobile} />
      </div>

      {
        loading &&
        <FullScreenLoading />
      }
    </div>
  )
}

export default WPSDashboardEent;
